import React from "react";
import companies from "../data/companies";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const Companies = () => {
  return (
    <section className="companies">
      <div className="container">
        <div className="row">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={50}
            slidesPerView={4}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }}
            loop={true}
            breakpoints={{
              0: {
                slidesPerView: 2
              },
              780: {
                slidesPerView: 2
              },
              991: {
                slidesPerView: 3
              },
              1200: {
                slidesPerView: 4
              }
            }}
          >
            {companies.map((company, index) => (
              <SwiperSlide key={index}>
                <Link 
                  to={company?.link} 
                  // target={company?.link ? "_blank" : ""}
                >
                  <figure className="mb-0">
                    <img className="company_image" src={company.src} alt="" />
                  </figure>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Companies;